/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from 'angular-calendar/dist/esm/src/pipes/calendarDate.pipe';
import * as i3 from 'angular-calendar/dist/esm/src/providers/calendarDateFormatter.provider';
import * as i4 from '../../../app/components/calendar-view';
import * as i5 from 'angular-calendar/dist/esm/src/directives/calendarNextView.directive';
import * as i6 from 'angular-calendar/dist/esm/src/directives/calendarPreviousView.directive';
import * as i7 from '../../../$$_gendir/node_modules/angular-calendar/dist/esm/src/components/month/calendarMonthView.component.ngfactory';
import * as i8 from 'angular-calendar/dist/esm/src/components/month/calendarMonthView.component';
import * as i9 from 'angular-calendar/dist/esm/src/providers/calendarUtils.provider';
import * as i10 from '@ngrx/store/src/store';
import * as i11 from '../../../app/services/modal';
const styles_CalendarViewComponent:any[] = ([] as any[]);
export const RenderType_CalendarViewComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_CalendarViewComponent,data:{}});
function View_CalendarViewComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted(-1,(null as any),[' | Today']))],(null as any),(null as any));
}
function View_CalendarViewComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),3,'div',[['class',
      'cvc__badge term-details']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(1,(null as any),['',','])),(_l()(),i0.ɵeld(2,
      0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i0.ɵted(3,(null as any),
      ['\nWeek ','']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.getTermEvent((<any>_v.parent).context.day).title;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _co.getTermWeek((<any>_v.parent).context.day);
    _ck(_v,3,0,currVal_1);
  });
}
function View_CalendarViewComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'div',[['class',
      'cvc__badge public-holiday']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(1,(null as any),['','']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.getPublicHolidayNameFromDay((<any>_v.parent).context.day);
    _ck(_v,1,0,currVal_0);
  });
}
function View_CalendarViewComponent_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'div',[['class',
      'cvc__badge extra-day']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(1,(null as any),['','']))],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.getExtraDayNameFromDay((<any>_v.parent).context.day);
    _ck(_v,1,0,currVal_0);
  });
}
function View_CalendarViewComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),13,'div',[['class',
      'calendar-view-cell']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),12,'div',[['class',
      'cvc__content-wrapper']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),i0.ɵdid(2,278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,
      i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,
      'ngClass']},(null as any)),i0.ɵpod(3,{'term':0,'today':1}),(_l()(),i0.ɵeld(4,
      0,(null as any),(null as any),3,'div',[['class','cvc__date']],(null as any),
      (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted(5,
      (null as any),['',''])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),
      1,(null as any),View_CalendarViewComponent_2)),i0.ɵdid(7,16384,(null as any),
      0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CalendarViewComponent_3)),
      i0.ɵdid(9,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_CalendarViewComponent_4)),i0.ɵdid(11,
          16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
              'ngIf']},(null as any)),(_l()(),i0.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_CalendarViewComponent_5)),i0.ɵdid(13,16384,(null as any),
          0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = 'cvc__content-wrapper';
        const currVal_1:any = _ck(_v,3,0,_co.isDayInTerm(_v.context.day),_co.isDayToday(_v.context.day));
        _ck(_v,2,0,currVal_0,currVal_1);
        const currVal_3:any = _co.isDayToday(_v.context.day);
        _ck(_v,7,0,currVal_3);
        const currVal_4:any = (_co.isDayInTerm(_v.context.day) && _co.isDayMonday(_v.context.day));
        _ck(_v,9,0,currVal_4);
        const currVal_5:any = _co.isDayPublicHoliday(_v.context.day);
        _ck(_v,11,0,currVal_5);
        const currVal_6:any = _co.isExtraDay(_v.context.day);
        _ck(_v,13,0,currVal_6);
      },(_ck,_v) => {
        var _co:any = _v.component;
        const currVal_2:any = _co.getDate(_v.context.day.date);
        _ck(_v,5,0,currVal_2);
      });
}
export function View_CalendarViewComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵpid(0,i2.CalendarDatePipe,[i3.CalendarDateFormatter,i0.LOCALE_ID]),
      (_l()(),i0.ɵand(0,[['customCellTemplate',2]],(null as any),0,(null as any),View_CalendarViewComponent_1)),
      (_l()(),i0.ɵeld(2,0,(null as any),(null as any),12,'div',[['class','calendar-view']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(3,0,(null as any),(null as any),11,'div',[['class','cv__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(4,0,(null as any),(null as any),7,'div',[['class','cv__header']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(5,0,(null as any),(null as any),6,'h2',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted(6,
          (null as any),['',''])),i0.ɵppd(7,3),(_l()(),i0.ɵeld(8,0,(null as any),(null as any),
          1,'a',[['class','cv__link-next-month'],['mwlCalendarNextView','']],(null as any),
          [[(null as any),'viewDateChange'],[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i4.CalendarViewComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,9).onClick()) !== false);
              ad = (pd_0 && ad);
            }
            if (('viewDateChange' === en)) {
              const pd_1:any = ((<any>(_co.date = $event)) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(9,16384,(null as any),0,i5.CalendarNextViewDirective,
          ([] as any[]),{view:[0,'view'],viewDate:[1,'viewDate']},{viewDateChange:'viewDateChange'}),
      (_l()(),i0.ɵeld(10,0,(null as any),(null as any),1,'a',[['class','cv__link-previous-month'],
          ['mwlCalendarPreviousView','']],(null as any),[[(null as any),'viewDateChange'],
          [(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i4.CalendarViewComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,11).onClick()) !== false);
          ad = (pd_0 && ad);
        }
        if (('viewDateChange' === en)) {
          const pd_1:any = ((<any>(_co.date = $event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(11,16384,(null as any),0,i6.CalendarPreviousViewDirective,
          ([] as any[]),{view:[0,'view'],viewDate:[1,'viewDate']},{viewDateChange:'viewDateChange'}),
      (_l()(),i0.ɵeld(12,0,(null as any),(null as any),2,'div',[['class','cv__calendar-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(13,0,(null as any),(null as any),1,'mwl-calendar-month-view',
          ([] as any[]),(null as any),[[(null as any),'dayClicked']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i4.CalendarViewComponent = _v.component;
            if (('dayClicked' === en)) {
              const pd_0:any = ((<any>_co.clickedDay($event)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i7.View_CalendarMonthViewComponent_0,i7.RenderType_CalendarMonthViewComponent)),
      i0.ɵdid(14,770048,(null as any),0,i8.CalendarMonthViewComponent,[i0.ChangeDetectorRef,
          i9.CalendarUtils,i0.LOCALE_ID],{viewDate:[0,'viewDate'],events:[1,'events'],
          weekStartsOn:[2,'weekStartsOn'],cellTemplate:[3,'cellTemplate']},{dayClicked:'dayClicked'})],
      (_ck,_v) => {
        var _co:i4.CalendarViewComponent = _v.component;
        const currVal_1:any = _co.view;
        const currVal_2:any = _co.date;
        _ck(_v,9,0,currVal_1,currVal_2);
        const currVal_3:any = _co.view;
        const currVal_4:any = _co.date;
        _ck(_v,11,0,currVal_3,currVal_4);
        const currVal_5:any = _co.date;
        const currVal_6:any = _co.events;
        const currVal_7:any = 1;
        const currVal_8:any = i0.ɵnov(_v,1);
        _ck(_v,14,0,currVal_5,currVal_6,currVal_7,currVal_8);
      },(_ck,_v) => {
        var _co:i4.CalendarViewComponent = _v.component;
        const currVal_0:any = i0.ɵunv(_v,6,0,_ck(_v,7,0,i0.ɵnov(_v,0),_co.date,(_co.view + 'ViewTitle'),
            'en'));
        _ck(_v,6,0,currVal_0);
      });
}
export function View_CalendarViewComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'calendar-view',
      ([] as any[]),(null as any),(null as any),(null as any),View_CalendarViewComponent_0,
      RenderType_CalendarViewComponent)),i0.ɵdid(1,245760,(null as any),0,i4.CalendarViewComponent,
      [i10.Store,i11.ModalService],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const CalendarViewComponentNgFactory:i0.ComponentFactory<i4.CalendarViewComponent> = i0.ɵccf('calendar-view',
    i4.CalendarViewComponent,View_CalendarViewComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvY29tcG9uZW50cy9jYWxlbmRhci12aWV3Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvY29tcG9uZW50cy9jYWxlbmRhci12aWV3LnRzIiwibmc6Ly8vVXNlcnMvamFzb24vc3JjL21hdHJpeC9jbGllbnQvc3JjL2FwcC9jb21wb25lbnRzL2NhbGVuZGFyLXZpZXcucHVnIiwibmc6Ly8vVXNlcnMvamFzb24vc3JjL21hdHJpeC9jbGllbnQvc3JjL2FwcC9jb21wb25lbnRzL2NhbGVuZGFyLXZpZXcudHMuQ2FsZW5kYXJWaWV3Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPG5nLXRlbXBsYXRlICNjdXN0b21DZWxsVGVtcGxhdGUgbGV0LWRheT1cImRheVwiIGxldC1sb2NhbGU9XCJsb2NhbGVcIj48ZGl2IGNsYXNzPVwiY2FsZW5kYXItdmlldy1jZWxsXCI+PGRpdiBjbGFzcz1cImN2Y19fY29udGVudC13cmFwcGVyXCIgW25nQ2xhc3NdPVwieyAndGVybSc6IGlzRGF5SW5UZXJtKGRheSksICd0b2RheSc6IGlzRGF5VG9kYXkoZGF5KSB9XCI+PGRpdiBjbGFzcz1cImN2Y19fZGF0ZVwiPnt7IGdldERhdGUoZGF5LmRhdGUpIH19PHNwYW4gKm5nSWY9XCJpc0RheVRvZGF5KGRheSlcIj4gfCBUb2RheTwvc3Bhbj48L2Rpdj48ZGl2IGNsYXNzPVwiY3ZjX19iYWRnZSB0ZXJtLWRldGFpbHNcIiAqbmdJZj1cImlzRGF5SW5UZXJtKGRheSkgJmFtcDsmYW1wOyBpc0RheU1vbmRheShkYXkpXCI+e3sgZ2V0VGVybUV2ZW50KGRheSkudGl0bGUgfX0sPGJyPlxuV2VlayB7eyBnZXRUZXJtV2VlayhkYXkpIH19PC9kaXY+PGRpdiBjbGFzcz1cImN2Y19fYmFkZ2UgcHVibGljLWhvbGlkYXlcIiAqbmdJZj1cImlzRGF5UHVibGljSG9saWRheShkYXkpXCI+e3sgZ2V0UHVibGljSG9saWRheU5hbWVGcm9tRGF5KGRheSkgfX08L2Rpdj48ZGl2IGNsYXNzPVwiY3ZjX19iYWRnZSBleHRyYS1kYXlcIiAqbmdJZj1cImlzRXh0cmFEYXkoZGF5KVwiPnt7IGdldEV4dHJhRGF5TmFtZUZyb21EYXkoZGF5KSB9fTwvZGl2PjwvZGl2PjwvZGl2PjwvbmctdGVtcGxhdGU+PGRpdiBjbGFzcz1cImNhbGVuZGFyLXZpZXdcIj48ZGl2IGNsYXNzPVwiY3ZfX2NvbnRlbnQtd3JhcHBlclwiPjxkaXYgY2xhc3M9XCJjdl9faGVhZGVyXCI+PGgyPnt7IGRhdGUgfCBjYWxlbmRhckRhdGU6KHZpZXcgKyAnVmlld1RpdGxlJyk6J2VuJyB9fTxhIGNsYXNzPVwiY3ZfX2xpbmstbmV4dC1tb250aFwiIG13bENhbGVuZGFyTmV4dFZpZXcgW3ZpZXddPVwidmlld1wiIFsodmlld0RhdGUpXT1cImRhdGVcIj48L2E+PGEgY2xhc3M9XCJjdl9fbGluay1wcmV2aW91cy1tb250aFwiIG13bENhbGVuZGFyUHJldmlvdXNWaWV3IFt2aWV3XT1cInZpZXdcIiBbKHZpZXdEYXRlKV09XCJkYXRlXCI+PC9hPjwvaDI+PC9kaXY+PGRpdiBjbGFzcz1cImN2X19jYWxlbmRhci13cmFwcGVyXCI+PG13bC1jYWxlbmRhci1tb250aC12aWV3IFt3ZWVrU3RhcnRzT25dPVwiMVwiIFt2aWV3RGF0ZV09XCJkYXRlXCIgW2V2ZW50c109XCJldmVudHNcIiAoZGF5Q2xpY2tlZCk9XCJjbGlja2VkRGF5KCRldmVudClcIiBbY2VsbFRlbXBsYXRlXT1cImN1c3RvbUNlbGxUZW1wbGF0ZVwiPjwvbXdsLWNhbGVuZGFyLW1vbnRoLXZpZXc+PC9kaXY+PC9kaXY+PC9kaXY+IiwiPGNhbGVuZGFyLXZpZXc+PC9jYWxlbmRhci12aWV3PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBc1A7TUFBQSx3RUFBOEI7YUFBQTs7O29CQUFxQjtNQUFBO01BQUEsZ0JBQTBGLDJDQUE4QjtNQUFBO01BQUEsNENBQUk7TUFBQTs7SUFBbEM7SUFBQTtJQUFrQztJQUFBOzs7O29CQUNwWTtNQUFBO01BQUEsZ0JBQXVFOzs7SUFBQTtJQUFBOzs7O29CQUE0QztNQUFBO01BQUEsZ0JBQTBEOzs7SUFBQTtJQUFBOzs7O29CQUQzSTtNQUFBO01BQUEsZ0JBQWdDO01BQUE7TUFBQSx1QkFBQTtrREFBQTtNQUFBLGtDQUFrQyx5QkFBbUU7TUFBQTtNQUFBLDBEQUF1QjtNQUFBLHdCQUF1QjtNQUFBLHNEQUFBO01BQUE7TUFBbUQ7YUFBQTtVQUFBLGlDQUN4UTtVQUFBLG9FQUFBO1VBQUE7Y0FBQSx3QkFBbUg7VUFBQSxzREFBQTtVQUFBOzs7UUFENUM7UUFBNkI7UUFBbEMsV0FBSyxVQUE2QixTQUFsQztRQUF5SjtRQUFOLFdBQU0sU0FBTjtRQUF3RjtRQUFyQyxXQUFxQyxTQUFyQztRQUNqTztRQUF2QyxZQUF1QyxTQUF2QztRQUFxSjtRQUFsQyxZQUFrQyxTQUFsQzs7O1FBRDJFO1FBQUE7Ozs7O01BQS9OO01BQytRO1VBQUE7TUFBMkI7VUFBQTtNQUFpQztVQUFBO01BQXdCO1VBQUEsMERBQUk7VUFBQSxxQ0FBbUQ7VUFBQTtVQUFBO1lBQUE7WUFBQTtZQUFBO2NBQUE7Y0FBQTtZQUFBO1lBQWlFO2NBQUE7Y0FBQTtZQUFBO1lBQWpFO1VBQUEsdUNBQUE7VUFBQTtNQUF5RjtVQUFBO1VBQUE7UUFBQTtRQUFBO1FBQUE7VUFBQTtVQUFBO1FBQUE7UUFBeUU7VUFBQTtVQUFBO1FBQUE7UUFBekU7TUFBQSx1Q0FBQTtVQUFBO01BQTRHO1VBQUE7TUFBa0M7VUFBQTtZQUFBO1lBQUE7WUFBZ0Y7Y0FBQTtjQUFBO1lBQUE7WUFBaEY7VUFBQTthQUFBO3VDQUFBO1VBQUE7OztRQUFwTDtRQUFjO1FBQWpFLFdBQW1ELFVBQWMsU0FBakU7UUFBb0o7UUFBYztRQUF6RSxZQUEyRCxVQUFjLFNBQXpFO1FBQTBMO1FBQWtCO1FBQXJDO1FBQXlGO1FBQWxILFlBQTRDLFVBQWtCLFVBQXJDLFVBQXlGLFNBQWxIOzs7UUFBMVI7WUFBQTtRQUFBOzs7O29CQ0R2VztNQUFBO3NDQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/$$_gendir/app/components/calendar-view.ngfactory.ts